module.exports = __webpack_public_path__ + "img/logo_havoline.4bfbbe35.png";